<template>
  <main class="medgel">
    <section class="medgel__header">
      <h1 class="medgel__title">MEDGEL</h1>
      <p class="medgel__subtitle">{{ $t('medgel.help')}}</p>
    </section>

    <section class="medgel__features">
      <div class="medgel__img">
        <img src="/img/medgel_img_main.jpg" alt="Medgel — медицинский силикон" />
      </div>
      <ul class="medgel__list">
        <li class="medgel__list-title">{{ $t('medgel.med')}}</li>
        <li><i class="fa-solid fa-arrow-right"></i>{{ $t('medgel.i')}}</li>
        <li><i class="fa-solid fa-arrow-right"></i>{{ $t('medgel.i2')}}</li>
        <li><i class="fa-solid fa-arrow-right"></i>{{ $t('medgel.i3')}}</li>
        <li><i class="fa-solid fa-arrow-right"></i>{{ $t('medgel.i4')}}</li>
        <li><i class="fa-solid fa-arrow-right"></i>{{ $t('medgel.i5')}}</li>
        <li><i class="fa-solid fa-arrow-right"></i>{{ $t('medgel.i6')}}</li>
        <li><i class="fa-solid fa-arrow-right"></i>{{ $t('medgel.i7')}}</li>
      </ul>
    </section>

    <section class="medgel__engraving">
      <div class="medgel__engraving-text">
        <h2>{{ $t('medgel.proof')}}</h2>
        <p>{{ $t('medgel.process')}}</p>
      </div>
      
      <div class="medgel__engraving-img">
        <img src="/img/engraving_img1.png" alt="Гравировка Silimed на Medgel" />
      </div>
    </section>

    <section class="medgel__results">
      <h2>{{ $t('medgel.weeks')}}</h2>
      <p class="medgel__results-note">{{ $t('medgel.note')}}</p>
      <div class="medgel__results-images">
        <img src="/img/changes_img_do1new.jpg" alt="До использования Medgel" />
        <img src="/img/changes_img_ot2new.jpg" alt="После использования Medgel" />
      </div>
      <p class="medgel__disclaimer">{{ $t('medgel.disc')}}</p>
    </section>

    <section class="medgel__usage">
      <h2>{{ $t('medgel.ex')}}</h2>
      <p>
        {{ $t('medgel.heal')}}
      </p>
    </section>

    <section class="medgel__mechanism">
      <h2>{{ $t('medgel.mech')}}</h2>
      <div class="medgel__steps">
        <div class="medgel__step">
          <img src="/img/action1.jpg" alt="Формирование рубца — этап 1" />
          <h3>{{ $t('medgel.form')}}</h3>
          <p>{{ $t('medgel.first')}}</p>
        </div>
        <div class="medgel__step">
          <img src="/img/action2.jpg" alt="Действие Medgel — этап 2" />
          <h3>{{ $t('medgel.medgel')}}</h3>
          <p>{{ $t('medgel.second')}}</p>
        </div>
        <div class="medgel__step">
          <img src="/img/action3.jpg" alt="Результат воздействия — этап 3" />
          <h3>{{ $t('medgel.result')}}</h3>
          <p>{{ $t('medgel.end')}}</p>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { useRouter } from 'vue-router'

export default {
  name: 'MedgelView',
  data() {
    return {
      showCurve: true
    }
  },
  setup() {
    const router = useRouter()

    function goToBiodesin() {
      router.push("/biodesain")
    }
    function goToStandard() {
      router.push("/standardline")
    }
    function goToType() {
      router.push("/type")
    }

    return { goToBiodesin, goToStandard, goToType }
  },
  mounted() {
    this.initAnimations();
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 🔹 метод для перевода
    switchLang(lang) {
      this.$i18n.locale = lang
    },

    initAnimations() {
      if (this.showCurve) {
        setTimeout(() => {
          const curveLine = document.querySelector('.curve-line');
          if (curveLine) {
            curveLine.classList.add('animate-curve');
          }
        }, 100);
      }

      const isElementInViewport = (el) => {
        const rect = el.getBoundingClientRect();
        return (
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 0.9 &&
          rect.bottom >= 0
        );
      };

      const handleScroll = () => {
        const elements = document.querySelectorAll('.animate-element');
        elements.forEach(element => {
          if (isElementInViewport(element)) {
            element.classList.add('animate');
          }
        });
      };

      window.addEventListener('load', handleScroll);
      window.addEventListener('scroll', handleScroll);
      handleScroll();
    },

    handleResize() {
      this.showCurve = window.innerWidth > 768;
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.medgel {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.medgel__header {
  text-align: center;
  margin-bottom: 30px;
  background-color: #0b8482;
  padding: 40px 20px;
  width: 100%;
}

.medgel__title {
  color: white;
  font-size: 2.2rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.medgel__subtitle {
  font-weight: 300;
  font-size: 1.8rem;
  color: #ffffff;
}

.medgel__features {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-bottom: 30px;
}

.medgel__img img {
  width: 100%;
  max-height: 350px;
  object-fit: contain;
}

.medgel__list {
  list-style: none;
  padding: 0;
  display: grid;
  gap: 15px;
}

.medgel__list-title {
  color: #3d3d3d;
  font-size: 1.5rem;
  font-weight: 400;
  padding-bottom: 10px;
}

.medgel__list li {
  color: #3d3d3d;
  font-size: 1rem;
  font-weight: 300;
  display: flex;
  gap: 10px;
  align-items: center;
}

.fa-arrow-right {
  color: #87c1c0;
  font-size: 0.875rem;
}

.medgel__engraving {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background-color: #FAFAFA;
  padding: 30px 20px;
  margin-bottom: 40px;
}

.medgel__engraving-text {
  width: 100%;
}

.medgel__engraving h2 {
  color: #252525;
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 15px;
}

.medgel__engraving p {
  color: #252525;
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.5;
}

.medgel__results {
  padding: 60px 0;
  display: grid;
  gap: 30px;
  margin-bottom: 40px;
}

.medgel__results h2 {
  color: #252525;
  font-size: 1.5rem;
  font-weight: 400;
  text-align: center;
}

.medgel__results-note {
  color: #252525;
  font-size: 0.875rem;
  font-weight: 400;
  text-align: center;
  max-width: 900px;
  margin: 0 auto;
  line-height: 1.5;
}

.medgel__results-images {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.medgel__results-images img {
  max-width: 100%;
  height: auto;
}

.medgel__disclaimer {
  text-align: center;
  font-size: 0.75rem;
  font-weight: 300;
  color: rgba(61, 61, 61, 0.49);
  margin-top: 20px;
}

.medgel__usage {
  text-align: center;
  background-color: #FAFAFA;
  padding: 60px 20px;
  margin-bottom: 40px;
}

.medgel__usage h2 {
  color: #252525;
  font-size: 1.5rem;
  font-weight: 400;
  margin-bottom: 20px;
}

.medgel__usage p {
  color: #252525;
  font-size: 1rem;
  font-weight: 400;
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.5;
}

.medgel__mechanism {
  background-color: #0b8482;
  padding: 60px 20px;
  margin-bottom: 40px;
}

.medgel__mechanism h2 {
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 400;
  text-align: center;
  margin-bottom: 30px;
}

.medgel__steps {
  display: grid;
  gap: 40px;
  max-width: 1200px;
  margin: 0 auto;
}

.medgel__step {
  display: flex;
  flex-direction: column;
}

.medgel__step img {
  width: 100%;
  height: auto;
  margin-bottom: 20px;
}

.medgel__step h3 {
  color: #ffffff;
  font-size: 1.25rem;
  font-weight: 300;
  margin-bottom: 15px;
}

.medgel__step p {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 200;
  line-height: 1.5;
}

/* Адаптивные стили */
@media (min-width: 576px) {
  .medgel__features {
    flex-direction: row;
    align-items: center;
  }
  
  .medgel__engraving {
    flex-direction: row;
    align-items: center;
  }
  
  .medgel__results-images {
    flex-direction: row;
    justify-content: center;
  }
}

@media (min-width: 768px) {
  .medgel__steps {
    grid-template-columns: repeat(3, 1fr);
  }
  
  .medgel__title {
    font-size: 2.5rem;
  }
  
  .medgel__subtitle {
    font-size: 2rem;
  }
}

@media (min-width: 992px) {
  .medgel__title {
    font-size: 3rem;
  }
  
  .medgel__engraving-text {
    width: 60%;
  }
  
  .medgel__engraving-img {
    width: 40%;
  }
}

@media (min-width: 1200px) {
  .medgel__title {
    font-size: 3.5rem;
  }
  
  .medgel__subtitle {
    font-size: 2.2rem;
  }
}
</style>